module.exports = __webpack_public_path__ + "img/text-align-justify.0e6c6307.svg";